import {API_ROUTES, DEFAULT_RESULT_SIZE} from 'lib/workperks/common/constants';
import {axios} from "lib/Init";

export default class ESSponsoredKeywordsService {
    _queryObject(query) {
        if (!query || query.length === 0) {
            return {match_all: {}};
        }

        return {
            'term': {
                'name.keyword': {
                    'value': query,
                }
            }
        };
    }

    _buildRequest(query) {
        let queryObject = this._queryObject(query);

        return {
            size: DEFAULT_RESULT_SIZE,
            from: 0,
            _source: true,
            query: {
                bool: {
                    must: [queryObject],
                    "filter": [
                        {
                            "term": {
                                "keywordActive": true
                            }
                        }
            ]
                },
            },
        };
    }

    async search(query?) {
        query = query && query.length > 0 ? query.toLowerCase() : null;
        let request = this._buildRequest(query);

        // Prod will return 404 if there is an error, don't panic
        // thinking it's the URL...
        return await axios
            .post(API_ROUTES.elasticsearch.sponsored_keyword, request)
            .then(response => {
                return response.data.hits.hits.map(perk => perk._source);
            })
            .catch(response => {
                console.error("Error-----Res", response);
            });
    }
}
